import { User } from '../../../../models/User';
import { UserRole } from '../../../../types/backendType';
import { FormMode } from '../../../commons/form/formUtils';

export const genderOptions = ['Male', 'Female', 'Other'] as const;
export const ethnicityOptions = [
  'Caucasian',
  'African American',
  'Asian',
  'Native American',
  'Alaska Native',
  'Native Hawaiian or other Pacific Islander',
  'Hindi (India)',
  'Middle east',
  'Hispanic and Latino',
  'South American',
  'Other',
] as const;

export type PatientInput = {
  id: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  email: string;
  height: number;
  creationDate: Date;
  isTestUser: boolean;
  weight?: number | undefined;
  surgeryDate?: string | undefined;
  medicalCondition?: string | undefined;
  gender?: string | undefined;
  ethnicity?: string | undefined;
  surgicalLeg?: string | undefined;
  dateOfBirth?: string | undefined;
  role: UserRole;
  emrPatientId?: string;
  // LEGACY patient-level diagnosis. No longer has form inputs — ICD-10 is
  // per-case now (see CasesInFormView's table). These are kept on the form
  // data ONLY so Save round-trips whatever is already stored: the user mapper
  // rebuilds additional_user_info wholesale, so dropping them here would WIPE
  // the stored values that the note prompt still falls back to for patients
  // whose cases carry no ICD-10 (see caseDiagnosis.ts). Remove after a
  // backfill moves those values onto cases.
  icd10Desc?: string;
  icd10Codes?: string;
  assessment?: string;
  primaryComplaint?: string;
  currentLevelOfFunction?: string;
  diagnosis?: string;
  // Goals + initial evaluation (+ their approved summaries), exactly as stored.
  // Edited in the Clinical info panel, never in this form - carried through so
  // a profile Save does not wipe them (see clinical-info/clinicalInfo.ts).
  clinicalInfo?: Record<string, unknown>;
};

export type PatientFormData = Partial<PatientInput> & {
  id: string;
  creationDate: Date;
  isTestUser: boolean;
  role: UserRole;
};

export const medicalConditionOptions = [
  'TKR/TKA',
  'Ligament repairs',
  'Meniscus repairs',
  'Knee scopes',
  'Quad/Patella Tendon repairs',
  'ORIF (open reduction internal fixation)',
  'Stem cell treatments',
  'Non-operative patients',
  'Other',
];

export const surgicalLegOptions = ['Left', 'Right', 'Both', 'None'];

export const editableFields: (keyof PatientInput)[] = [
  'height',
  'firstName',
  'middleName',
  'lastName',
  'weight',
  'surgeryDate',
  'medicalCondition',
  'gender',
  'ethnicity',
  'surgicalLeg',
  'dateOfBirth',
  'emrPatientId',
  // icd10Desc / icd10Codes intentionally absent: they no longer have form
  // inputs (ICD-10 is edited per case in the Cases & ICD-10 table). They stay
  // on PatientInput so Save round-trips the stored legacy values.
];

export type PatientFormMode =
  | FormMode<User>
  | { mode: 'newTestUser' }
  | { mode: 'new'; emrPatientId?: string };
